import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import { lazy } from 'react';

export const MtAllocateRuleListFactory = reactContainerFactory({
  name: 'ruleCenter.allocateRule.mt.list',
});

export const MtAllocateRuleFormFactory = reactContainerFactory({
  name: 'ruleCenter.allocateRule.mt.form',
});

export const MtAllocateRuleList = () =>
  lazy(
    () => import('@/react-app/pages/rule-center/allocate-rule/mt-outbound/list')
  );

export const MtAllocateRuleForm = () =>
  lazy(
    () =>
      import('@/react-app/pages/rule-center/allocate-rule/mt-outbound/create')
  );
